/* ================================================================
   AISTROWISE — PDP (aw-product) behaviour. No libraries.
   1. Example-report modal open/close (theme-style, hidden attribute).
   2. Sticky mobile buy bar: shown whenever the main buy button is off-screen.
   3. Cross-sell "comprados frecuentemente juntos": live total (presentment
      currency) + add main product and checked add-ons via the AJAX cart.
   Main add-to-cart works with no JS (plain form POST to /cart/add).
   ================================================================ */
(function () {
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Publish the visible sticky-bar height so the WhatsApp bubble can ride above
  // it (bar height varies: the horóscopo CTA wraps to two lines). Height is read
  // only on show/hide change, so no per-scroll reflow.
  function awBubbleBar(bar, show) {
    var root = document.documentElement;
    if (show) {
      root.style.setProperty('--aw-bar-h', bar.offsetHeight + 'px');
      document.body.classList.add('aw-bar-shown');
    } else {
      document.body.classList.remove('aw-bar-shown');
      root.style.removeProperty('--aw-bar-h');
    }
  }

  // El total del cross-sell es el único precio que nace en el navegador, y hasta
  // el 10-sep lo escribía Intl: con es-ES imprimía «1247,00 MXN» justo debajo del
  // «$ 499.00» que acababa de renderizar Liquid en la misma tarjeta. Ahora el
  // formato se APRENDE de una muestra que sí escribió Shopify (data-money-sample,
  // 1234567 céntimos pasados por el filtro money): prefijo, sufijo, separador de
  // miles, separador decimal y cuántos decimales usa este mercado. Nada se inventa.
  function moneyPattern(sample) {
    var s = String(sample || '');
    var first = s.search(/\d/);
    if (first < 0) return null;
    var last = s.length - 1;
    while (last >= 0 && !/\d/.test(s.charAt(last))) last--;
    var num = s.slice(first, last + 1);
    var seps = [];
    for (var i = 0; i < num.length; i++) {
      var ch = num.charAt(i);
      if (/\d/.test(ch)) continue;
      // Solo los tres separadores que usa Shopify entre dígitos. Cualquier otra
      // cosa dentro de la parte numérica significa que no entendemos la muestra,
      // y prefiero no escribir nada a escribir un importe mal agrupado.
      if (ch !== '.' && ch !== ',' && ch !== "'") return null;
      seps.push({ ch: ch, at: i });
    }
    var decimals = 0, dec = '', group = '';
    // Dos dígitos después del último separador = moneda con decimales (EUR, MXN,
    // PEN). Tres = ese separador era de miles y la moneda no lleva decimales
    // (CLP, PYG), que es justo lo que distingue «12,346» de «12,34». Las monedas
    // de tres decimales (dinares) caerían del lado de los miles y saldrían mal,
    // pero ninguna de las 13 monedas de presentación de la tienda lo es.
    if (seps.length && num.slice(seps[seps.length - 1].at + 1).length === 2) {
      decimals = 2;
      dec = seps[seps.length - 1].ch;
      if (seps.length > 1) group = seps[0].ch;
    } else if (seps.length) {
      group = seps[0].ch;
    }
    return { prefix: s.slice(0, first), suffix: s.slice(last + 1), group: group, dec: dec, decimals: decimals };
  }

  // Solo la cifra, sin marcado. null cuando la muestra no sirve.
  function moneyAmount(cents, sample) {
    var n = parseInt(cents, 10) || 0;
    var p = moneyPattern(sample);
    // Sin muestra utilizable no hay forma honesta de escribir dinero aquí: se
    // devuelve null y quien llama deja en pie el total que ya pintó el servidor,
    // que siempre es correcto aunque no sume los complementos marcados.
    if (!p) return null;
    var neg = n < 0;
    if (neg) n = -n;
    var whole = p.decimals === 2 ? Math.floor(n / 100) : Math.round(n / 100);
    var digits = String(whole);
    if (p.group) digits = digits.replace(/\B(?=(\d{3})+(?!\d))/g, p.group);
    var out = (neg ? '-' : '') + p.prefix + digits;
    if (p.decimals === 2) out += p.dec + String((n % 100) + 100).slice(1);
    return out + p.suffix;
  }

  // La MISMA estructura que imprime el snippet aw-price, envoltura incluida: en
  // los mercados cuyo formato lleva espacio tras el símbolo («$ 947.00»), sin el
  // span con white-space: nowrap el navegador partía la línea justo ahí y dejaba
  // el símbolo huérfano («Total $» / «947.00 MXN») en el móvil.
  function fmtMoney(cents, sample, code) {
    var amount = moneyAmount(cents, sample);
    if (amount === null) return null;
    var out = '<span class="aw-price">' + amount;
    // La etiqueta ISO solo cuando el servidor dijo que hacía falta, y solo si el
    // atributo trae un código de verdad: nada de lo que llegue por el DOM se
    // escribe tal cual dentro de innerHTML.
    if (/^[A-Za-z]{2,5}$/.test(String(code || ''))) {
      out += '<small class="aw-price__code">' + code + '</small>';
    }
    return out + '</span>';
  }
  // Publicado para la suite (tests/aw-price-2026-09-10.test.js), que lo carga en
  // una VM con un DOM mínimo y comprueba los seis formatos de mercado: la cifra
  // pelada por .amount y la envoltura por la función.
  window.awFormatMoney = fmtMoney;
  window.awFormatMoney.amount = moneyAmount;

  function initStickyBar(root) {
    var bar = root.querySelector('[data-aw-pdp-stickybar]');
    if (!bar) return;
    var buy = root.querySelector('[data-aw-pdp-buy]');
    var lastShow = null;
    function update() {
      var visible = false;
      if (buy) {
        var r = buy.getBoundingClientRect();
        visible = r.top < window.innerHeight && r.bottom > 0;
      }
      var show = !visible;
      if (show === lastShow) return;
      lastShow = show;
      bar.classList.toggle('is-show', show);
      awBubbleBar(bar, show);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initCrossSell(root) {
    var fbt = root.querySelector('[data-aw-pdp-fbt]');
    if (!fbt) return;
    // Cuota plegada (founder 2026-09-21): el botón vive dentro del label, así que
    // se corta el clic para que abrir la cuota no marque ni desmarque la casilla.
    fbt.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-aw-fbt-terms-toggle]');
      if (!t) return;
      e.preventDefault();
      var open = t.getAttribute('aria-expanded') === 'true';
      t.setAttribute('aria-expanded', open ? 'false' : 'true');
      var box = document.getElementById(t.getAttribute('aria-controls'));
      if (box) box.hidden = open;
    });
    var cbs = Array.prototype.slice.call(fbt.querySelectorAll('.aw-pdp__fbt-cb'));
    var totalEl = fbt.querySelector('[data-aw-pdp-fbt-total]');
    var addBtn = fbt.querySelector('[data-aw-pdp-fbt-add]');
    var base = parseInt(fbt.getAttribute('data-base-price'), 10) || 0;
    var baseVariant = fbt.getAttribute('data-base-variant');
    var baseSellingPlan = fbt.getAttribute('data-base-selling-plan');
    var sample = fbt.getAttribute('data-money-sample') || '';
    var code = fbt.getAttribute('data-money-code') || '';

    // Paquete con código (2026-09-10): si lo marcado coincide exactamente con
    // las variantes del paquete, el total pasa a ser el del código, con el
    // total normal tachado, y el botón manda al pago por permalink con
    // ?discount=CODIGO. El reparto por línea trunca a céntimos como Shopify
    // (mismo cálculo que sections/aw-pack.liquid).
    var packIds = (fbt.getAttribute('data-pack-ids') || '').split(',').filter(Boolean);
    var packCode = fbt.getAttribute('data-pack-code') || '';
    var packBp = parseInt(fbt.getAttribute('data-pack-bp'), 10) || 0;
    var packCta = fbt.getAttribute('data-pack-cta') || '';
    var wasEl = fbt.querySelector('[data-aw-pdp-fbt-was]');
    var noteEl = fbt.querySelector('[data-aw-pdp-fbt-packnote]');
    var addLabel = addBtn ? addBtn.textContent : '';
    var addEvent = addBtn ? addBtn.getAttribute('data-aw-event') : '';
    var packActive = false;

    var updateUrl = fbt.getAttribute('data-update-url') || '/cart/update';

    function selected() {
      // El plan se lee del atributo en cada llamada: el selector de planes
      // (initSubscription) lo cambia ahí, y la copia de arriba se quedaba en
      // el mensual aunque la visitante eligiera el anual (2026-10-08).
      var items = [{ id: String(baseVariant), price: base, plan: fbt.getAttribute('data-base-selling-plan') || baseSellingPlan || '' }];
      each(cbs, function (cb) {
        if (cb.checked && cb.getAttribute('data-variant')) {
          items.push({
            id: cb.getAttribute('data-variant'),
            price: parseInt(cb.getAttribute('data-price'), 10) || 0,
            plan: cb.getAttribute('data-selling-plan') || ''
          });
        }
      });
      return items;
    }
    // Paquete activo cuando TODAS sus variantes van marcadas. Lo demás que vaya
    // marcado (el horóscopo, founder 2026-09-14) se suma a su precio y no rompe
    // la oferta: el código solo descuenta los productos del paquete.
    function isPack(items) {
      if (!packIds.length || !packCode || packBp <= 0) return false;
      var ids = items.map(function (it) { return it.id; });
      for (var i = 0; i < packIds.length; i++) { if (ids.indexOf(packIds[i]) === -1) return false; }
      return true;
    }
    function packTotal(items) {
      var t = 0;
      each(items, function (it) {
        t += packIds.indexOf(it.id) === -1 ? it.price : it.price - Math.floor(it.price * packBp / 10000);
      });
      return t;
    }
    function lineItems(items) {
      return items.map(function (it) {
        var line = { id: it.id, quantity: 1 };
        if (it.plan) line.selling_plan = it.plan;
        return line;
      });
    }
    function postJson(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      });
    }

    function update() {
      var items = selected();
      var listTotal = 0;
      each(items, function (it) { listTotal += it.price; });
      packActive = isPack(items);
      var t = packActive ? packTotal(items) : listTotal;
      var html = fmtMoney(t, sample, code);
      if (totalEl && html !== null) totalEl.innerHTML = html;
      if (wasEl) {
        var wasHtml = fmtMoney(listTotal, sample, '');
        if (packActive && wasHtml !== null) wasEl.innerHTML = wasHtml;
        wasEl.hidden = !packActive;
      }
      if (noteEl) noteEl.hidden = !packActive;
      if (addBtn) {
        addBtn.textContent = packActive && packCta ? packCta : addLabel;
        addBtn.setAttribute('data-aw-event', packActive ? 'pdp_fbt_pack_checkout' : addEvent);
      }
      // Código de la visitante (aw-discount-price.js, 2026-10-08): el total de
      // ESTA selección se le pregunta a Shopify, nunca se suman los precios
      // rebajados de cada fila, porque un importe fijo por pedido no se
      // descuenta una vez por producto. Con el paquete activo manda el paquete
      // (su botón aplica su propio código). Sin respuesta, queda el de lista.
      // Se pregunta ya, en paralelo con los precios sueltos, y el total espera
      // oculto (aw-dp-pending) en vez de saltar de la cifra de lista a la otra.
      var seq = ++quoteSeq;
      if (totalEl) totalEl.classList.remove('aw-dp-pending');
      if (packActive || !window.awDiscount || !window.awDiscount.pending) return;
      if (totalEl) totalEl.classList.add('aw-dp-pending');
      window.awDiscount.quote(items.map(function (it) { return { id: it.id, plan: it.plan }; }), function (q) {
        if (seq !== quoteSeq) return;
        if (totalEl) totalEl.classList.remove('aw-dp-pending');
        if (!q || q.full !== listTotal) return;
        var nowHtml = fmtMoney(q.now, sample, code);
        var fullHtml = fmtMoney(q.full, sample, '');
        if (nowHtml === null || fullHtml === null) return;
        if (totalEl) totalEl.innerHTML = nowHtml;
        if (wasEl) {
          wasEl.innerHTML = fullHtml;
          wasEl.hidden = false;
        }
      });
    }
    var quoteSeq = 0;
    each(cbs, function (cb) { cb.addEventListener('change', update); });

    // Plan del selector (2026-10-08): la fila «Este producto» trae su precio y su
    // cuota una vez por plan (data-aw-fbt-plan). Se enseñan los del plan elegido y
    // el total suma su primer cobro. Antes la fila se quedaba en el mensual, 0 y
    // «Primer mes sin cargo», con el anual elegido y cobrado en el carrito.
    var planRows = fbt.querySelectorAll('[data-aw-fbt-plan]');
    function syncPlan(radio) {
      var first = null;
      each(planRows, function (n) {
        if (n.getAttribute('data-aw-fbt-plan') === radio.value && n.hasAttribute('data-first')) first = n.getAttribute('data-first');
      });
      if (first === null) return;
      each(planRows, function (n) { n.hidden = n.getAttribute('data-aw-fbt-plan') !== radio.value; });
      fbt.setAttribute('data-base-selling-plan', radio.value);
      base = parseInt(first, 10) || 0;
    }
    if (planRows.length) {
      each(root.querySelectorAll('[data-aw-plan-radio]'), function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          syncPlan(radio);
          update();
        });
        // El navegador puede devolver el anual ya marcado al volver atrás.
        if (radio.checked) syncPlan(radio);
      });
    }
    update();

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = selected();
        var cartUrl = fbt.getAttribute('data-cart-url');
        var hasPlan = false;
        each(items, function (it) { if (it.plan) hasPlan = true; });
        if (packActive && !hasPlan) {
          var ids = items.map(function (it) { return it.id + ':1'; }).join(',');
          window.location = cartUrl + '/' + ids + '?discount=' + encodeURIComponent(packCode);
          return;
        }
        addBtn.disabled = true;
        var prev = addBtn.textContent;
        addBtn.textContent = 'Añadiendo…';
        var req = postJson(fbt.getAttribute('data-add-url') + '.js', { items: lineItems(items) });
        if (packActive) {
          // El permalink del carrito no admite planes de suscripción (410,
          // medido 2026-09-14): con el horóscopo marcado, el código se aplica
          // por cart/update y se salta directo al pago. Si el código no cuaja,
          // el carrito enseña el total real en vez de prometer uno falso.
          req = req.then(function () {
            return postJson(updateUrl + '.js', { discount: packCode });
          }).then(function (cart) {
            var codes = (cart && cart.discount_codes) || [];
            var ok = false;
            each(codes, function (c) {
              if (c && c.applicable && String(c.code).toUpperCase() === packCode.toUpperCase()) ok = true;
            });
            window.location = ok ? '/checkout' : cartUrl;
          });
        } else {
          req = req.then(function () { window.location = cartUrl; });
        }
        req.catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = prev;
        });
      });
    }
  }

  function initSubscription(root) {
    // Horóscopo PDPs render the native plan picker (aw-plan-picker snippet):
    // radios named selling_plan inside the main form, so the buy box posts the
    // chosen plan with no JS. Here we only mirror the pick into the sticky-bar
    // hidden input + the FBT bundle, and swap the displayed monthly price.
    var radios = root.querySelectorAll('[data-aw-plan-radio]');
    if (!radios.length) return;
    var hiddens = root.querySelectorAll('[data-aw-pdp-sellingplan]');
    var priceNow = root.querySelector('[data-aw-pdp-price] .aw-pdp__price-now');
    var barPrice = root.querySelector('[data-aw-pdp-stickybar] .aw-pdp__buybar-price b');
    var fbt = root.querySelector('[data-aw-pdp-fbt]');

    each(radios, function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        each(hiddens, function (input) { input.value = radio.value; });
        if (fbt) fbt.setAttribute('data-base-selling-plan', radio.value);
        var display = radio.getAttribute('data-plan-display');
        if (display) {
          // data-plan-display lleva el marcado de aw-price (cifra + etiqueta ISO).
          if (priceNow) priceNow.innerHTML = display;
          if (barPrice) barPrice.innerHTML = display;
        }
      });
    });
  }

  function initModals() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest && e.target.closest('[data-aw-modal-open]');
      if (opener) {
        var m = document.getElementById(opener.getAttribute('data-aw-modal-open'));
        if (m) {
          var wasHidden = m.hidden;
          m.hidden = false; document.body.style.overflow = 'hidden';
          if (wasHidden && window.awTrack) window.awTrack('example_report_open'); // once per open
        }
        return;
      }
      if (e.target.closest && e.target.closest('[data-aw-modal-close]')) {
        var modal = e.target.closest('[data-aw-modal]');
        if (modal) { modal.hidden = true; document.body.style.overflow = ''; }
        return;
      }
      // Clic fuera del panel: el objetivo es el propio contenedor. No depende
      // de que el velo exista, que es lo que se rompió con `div:empty` de Dawn.
      if (e.target.matches && e.target.matches('[data-aw-modal]')) {
        e.target.hidden = true; document.body.style.overflow = '';
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        each(document.querySelectorAll('[data-aw-modal]:not([hidden])'), function (m) {
          m.hidden = true; document.body.style.overflow = '';
        });
      }
    });
  }

  ready(function () {
    each(document.querySelectorAll('[data-aw-product]'), function (root) {
      initStickyBar(root);
      initCrossSell(root);
      initSubscription(root);
    });
    initModals();
  });
})();
